import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/Button';
import InnerCircle from '@assets/InnerCircle.png';
import { Icon } from '@components/icon';
import { Typography } from '@mui/material';
import ellipseOutside from '../../assets/icons/ellipse-outside.svg';
import useMediaQuery from '@mui/material/useMediaQuery';

export const Container = styled(Grid).attrs({
  container: true,
  component: 'main',
  sx: { height: '100vh' },
})``;

export const Square = styled(Box).attrs({
  width: 40,
  bgcolor: 'white.dark',
  flex: 1,
  flexDirection: 'column',
})``;



export const LeftContent = styled(Grid).attrs({
  zIndex: -1,
  xs: false,
  sm: 4,
  md: 7,
  container: true,
  alignContent: 'center',
  justifyContent: 'center',
  position: 'relative',
  minHeight: '50px',
})`
  background: ${({ theme }) => theme.gradients.secondary};
  overflow: hidden;
`;

export const RightContent = styled(Grid).attrs({
  xs: 12,
  sm: 8,
  md: 5,
  mt: 18,
  alignItems: 'center',
  justifyContent: 'center',
  px: {xs: 3, sm: 8, md: 15, xl: 15}
})``;

export const Button = styled(ButtonBase).attrs({
  variant: 'contained',
  width:'200px',
  sx: { mt: 3, mb: 2, fontWeight: 700, fontSize: 16 },
})`
  background: ${({ theme }) => theme.gradients.primary};
  font-family: 'Mukta';
`;


export const ButtonWrapper = styled(Box).attrs({
  display: 'flex',
  float:'right',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'right',
})``;

export const UnderlineButton = styled(ButtonBase).attrs({
  sx: {
    textDecoration: 'underline',
    color: 'black.light',
  },
})``;


export const InfoClass = styled(ButtonBase).attrs({
  variant: 'contained',
  width:'200px',
  sx: { mt: 3, mb: 2, fontWeight: 700, fontSize: 16 },
})`
  background: ${({ theme }) => theme.gradients.primary};
  font-family: 'Mukta';
  color: white;
`;


export const Input = styled(Box).attrs({
  variant: 'contained',
  width:'200px',
  sx: { mt: 3, mb: 2, fontWeight: 700, fontSize: 16 },
})``;


export const ModalContainer = styled(Box).attrs({
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2
})`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
    height: 100%;
    max-height: 100%;
    padding: 16px;
    border-radius: 0;
  }
`;

export const ModalContent = styled(Box)`
  overflow-y: auto;
  box-sizing: border-box;
  max-height: 70vh;
  max-width: 80vw;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    max-height: 100%;
    max-width: 100%;
    flex: 1;
  }
`;

export const ButtonYes = styled(Button).attrs({
  sx: {
    mt: 3,
    mb: 2,
    fontWeight: 700,
    fontSize: 16,
    color: 'white.main',
    fontFamily: 'Mukta',
    minWidth:'130px',
  },
})`
  background: ${({ theme }) => theme.gradients.primary};
`;

export const ButtonNo = styled(Button).attrs({
  sx: {
    mt: 3,
    mb: 2,
    fontWeight: 700,
    fontSize: 16,
    color: 'white.main',
    fontFamily: 'Mukta',
    minWidth:'130px',
  },
})`
  border: 1px solid rgba(165, 16, 51, 1) !important;
  color: gray;
`;


export const ButtonContainer = styled(Box).attrs({
  display: 'flex',
  gap: '24px',
})``;
